


























































































import Vue from 'vue'
import { api } from '@/singleton'
import mixins from 'vue-typed-mixins'
import { generalDialogMixin } from '@/mixins'
import easyapi from '@/easyapi'
import { deepCopy, generateUnoccupiedId, checkNameDuplicated, getMatrixMap, getMatrixList } from '@/utils'
import { isEqual } from 'lodash'
import { ApiVw, Matrix, Extender, Preset } from '@/types/api'
import VwPreviewScreen from '@/components/VwPreviewScreen.vue'
import PreviewScreen from '@/components/PreviewScreen.vue'
import CheckboxIcon from '@/components/CheckboxIcon.vue'
import { MatrixMap, getDevRef } from '@/store/modules/device'
import { IDevice } from '@/types/model'
import VueI18n from 'vue-i18n'

// interface PresetVw extends ApiVw {
//   conflictRxs: Extender[]
// }
//
// interface PresetMatrix extends Matrix {
//   conflictWithVw: boolean
// }

//
type step_t = -1 | 1 | 2

interface DialogVisibility {
  desktop: boolean
  mobile: step_t
}

const DEFAULT_PRESET: Preset = {
  id: -1,
  name: '',
  note: '',
  vwList: [],
  matrixList: []
}

export default mixins(generalDialogMixin).extend({
  components: {
    PreviewScreen,
    VwPreviewScreen,
    CheckboxIcon,
  },
  data (): {
    getDevRef: typeof getDevRef,
    step: step_t
    nameFilterStr: string,
    preset: Preset,
    selected: {
      vwIdList: number[],
      matrixRxMacList: string[],
    }
  } {
    return {
      getDevRef,
      step: 1,
      nameFilterStr: '',
      preset: deepCopy(DEFAULT_PRESET),
      selected: {
        vwIdList: [],
        matrixRxMacList: []
      }
    }
  },
  computed: {
    matrixList (): Matrix[] { return getMatrixList(this.$state) },
    matrixMap (): MatrixMap { return getMatrixMap(this.$state) },
    vwList (): ApiVw[] { return this.$state.device.vwList },
    dialogVisibility (): DialogVisibility {
      const tmp: DialogVisibility = { desktop: false, mobile: -1 }
      if (!this.dialog.show) { return tmp }
      if (this.$state.common.windowSize.width > 600) {
        tmp.desktop = true
      } else {
        tmp.mobile = this.step
      }
      return tmp
    },
    disableApply (): boolean {
      return !this.preset.name ||
      !!this.alertData.text ||
      (this.selected.vwIdList.length === 0 && this.selected.matrixRxMacList.length === 0) },
    /** If same RX be using in selected Matrix + VW */
    duplicatedRxs (): string[] {
      const seen: string[] = []
      const duplicated: string[] = []
      for (const vwid of this.selected.vwIdList) {
        const vw = this.vwList.find(x => x.id === vwid)
        if (!vw) { console.warn('[Impossible]'); continue }
        for (const rx of vw.rxList) {
          if (rx.mac === '') {continue}
          if (seen.includes(rx.mac)) {
            duplicated.push(rx.mac)
          }
          seen.push(rx.mac)
        }
      }
      for (const rxMac of this.selected.matrixRxMacList) {
        if (rxMac === '') { console.warn('[To Developer] Imporssible'); continue}
        if (seen.includes(rxMac)) {
          duplicated.push(rxMac)
        }
        seen.push(rxMac)
      }
      return duplicated
    },
    alertData (): {type: string, text: VueI18n.TranslateResult} {
      if (!this.preset.name) {
        return { type: 'info', text: this.$t('msg.nameIsRequired') }
      }
      if (this.nameDuplicated) {
        return { type: 'warning', text: this.$t('msg.nameCannotDuplicated') }
      }
      if (this.selected.matrixRxMacList.length === 0 && this.selected.vwIdList.length === 0) {
        return { type: 'info', text: this.$t('preset.create.help') }
      }
      if (this.duplicatedRxs.length !== 0) {
        return { type: 'warning', text: this.$t('preset.create.conflict') }
      }
      return {
        type: 'info',
        text: ''
      }
    },
    nameDuplicated (): boolean {
      return checkNameDuplicated(this.preset.name, null, this.$state.device.presetList)
    }
  },
  methods: {
    toggleMatrix (matrix: Matrix) {
      const l = this.selected.matrixRxMacList
      const idx = l.indexOf(matrix.rxMac)
      if (idx === -1) {
        l.push(matrix.rxMac)
      } else {
        l.splice(idx, 1)
      }
    },
    toggleVw (vw: ApiVw) {
      const l = this.selected.vwIdList
      const idx = l.indexOf(vw.id)
      if (idx === -1) {
        l.push(vw.id)
      } else {
        l.splice(idx, 1)
      }
    },
    getDevName (mac: string): string {
      const dev = getDevRef(mac)
      if (dev) { return this.dn(dev) }
      return '[Not Found]'
    },
    apply () {
      this.preset.vwList = this.$state.device.vwList.filter(x => this.selected.vwIdList.includes(x.id))
      this.preset.matrixList = this.matrixList.filter(x => this.selected.matrixRxMacList.includes(x.rxMac))
      easyapi.createPreset(this.preset).then(ok => {
        if (ok) {
          this.closeThisDialog()
        }
      })
    },
  },
  watch: {
    'dialog.show' (nv: boolean) {
      if (nv) {
        this.step = 1
        const preset = deepCopy(DEFAULT_PRESET)
        preset.id = generateUnoccupiedId(this.$state.device.presetList)
        easyapi.getAllVw()
      }
    }
  }
})
